import { render, staticRenderFns } from "./NewBigMap.vue?vue&type=template&id=913bc9a2&scoped=true"
import script from "./NewBigMap.vue?vue&type=script&lang=js"
export * from "./NewBigMap.vue?vue&type=script&lang=js"
import style0 from "./NewBigMap.vue?vue&type=style&index=0&id=913bc9a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913bc9a2",
  null
  
)

export default component.exports